import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

/**
 * logEvento — registra un evento nella collection `eventi`
 * Chiamare ogni volta che accade qualcosa di significativo in Nexiora.
 *
 * @param {object} params
 * @param {string} params.orgId
 * @param {string} params.tipo         — es. "commessa_creata", "task_completato", ecc.
 * @param {string} params.categoria    — "commesse"|"clienti"|"attivita"|"presenze"|"noteSpese"|"acquisti"|"rapportini"|"scadenze"|"verbali"
 * @param {string} params.titolo       — testo breve visibile nel feed
 * @param {string} [params.descrizione]— dettaglio opzionale
 * @param {string} params.uid          — uid di chi ha fatto l'azione
 * @param {string} params.nomeUtente   — nome leggibile di chi ha fatto l'azione
 * @param {string} [params.refId]      — id dell'oggetto collegato
 * @param {string} [params.refTipo]    — tipo oggetto: "project"|"task"|"cliente"|ecc.
 * @param {string} [params.refNome]    — nome leggibile dell'oggetto
 * @param {string} [params.clienteId]
 * @param {string} [params.clienteNome]
 * @param {string} [params.projectId]
 * @param {string} [params.projectName]
 * @param {string} [params.priorita]   — "info"|"medio"|"alto"|"critico" (default "info")
 * @param {object} [params.navigateTo] — destinazione click nel feed { page, projectId, tab }
 */
export async function logEvento({
  orgId, tipo, categoria = "", titolo = "", descrizione="",
  uid, nomeUtente,
  refId="", refTipo="", refNome="",
  clienteId="", clienteNome="",
  projectId="", projectName="",
  priorita="info",
  navigateTo=null,
}) {
  // W422: alcune chiamate (chiusura e archiviazione commessa) non passavano titolo e
  // categoria, e l'evento veniva scartato in silenzio: ora si ricavano dal tipo.
  if (!titolo && tipo) {
    const leggibile = String(tipo).toLowerCase().replace(/_/g, " ");
    titolo = leggibile.charAt(0).toUpperCase() + leggibile.slice(1) + (projectName ? `: ${projectName}` : "");
  }
  if (!categoria && /^commessa/i.test(String(tipo || ""))) categoria = "commesse";
  if(!orgId || !tipo || !titolo) return;
  try {
    await addDoc(collection(db,"eventi"), {
      orgId, tipo, categoria, titolo, descrizione,
      uid: uid||"", nomeUtente: nomeUtente||"Sistema",
      refId, refTipo, refNome,
      clienteId, clienteNome,
      projectId, projectName,
      priorita,
      navigateTo: navigateTo ? JSON.stringify(navigateTo) : null,
      createdAt: serverTimestamp(),
    });
  } catch(e) {
    // Non bloccare mai l'app per un log fallito
    console.warn("logEvento error:", e);
  }
}

// ── Tipi evento predefiniti ──────────────────────────────────
export const TIPI_EVENTO = {
  // Commesse
  COMMESSA_CREATA:       { categoria:"commesse",  priorita:"info",   emoji:"📁" },
  COMMESSA_CHIUSA:       { categoria:"commesse",  priorita:"info",   emoji:"✅" },
  // Attività
  TASK_CREATO:           { categoria:"attivita",  priorita:"info",   emoji:"📌" },
  TASK_COMPLETATO:       { categoria:"attivita",  priorita:"info",   emoji:"✔️" },
  TASK_ASSEGNATO:        { categoria:"attivita",  priorita:"info",   emoji:"👤" },
  TASK_IN_RITARDO:       { categoria:"attivita",  priorita:"alto",   emoji:"⏰" },
  // Clienti
  CLIENTE_CREATO:        { categoria:"clienti",   priorita:"info",   emoji:"🏢" },
  // Note spese
  NOTA_SPESE_INVIATA:    { categoria:"noteSpese", priorita:"info",   emoji:"💳" },
  NOTA_SPESE_APPROVATA:  { categoria:"noteSpese", priorita:"info",   emoji:"✅" },
  NOTA_SPESE_RESPINTA:   { categoria:"noteSpese", priorita:"medio",  emoji:"❌" },
  // Acquisti
  NF_CREATA:             { categoria:"acquisti",  priorita:"info",   emoji:"🛒" },
  NF_EVASA:              { categoria:"acquisti",  priorita:"info",   emoji:"📦" },
  // Rapportini
  RAPPORTINO_CREATO:     { categoria:"rapportini",priorita:"info",   emoji:"📋" },
  // Presenze
  CARTELLINO_APPROVATO:  { categoria:"presenze",  priorita:"info",   emoji:"🕐" },
  CARTELLINO_RESPINTO:   { categoria:"presenze",  priorita:"medio",  emoji:"⚠️" },
  // Scadenze
  SCADENZA_COMPLETATA:   { categoria:"scadenze",  priorita:"info",   emoji:"📅" },
  SCADENZA_SCADUTA:      { categoria:"scadenze",  priorita:"critico",emoji:"🔴" },
  // Verbali
  VERBALE_CREATO:        { categoria:"verbali",   priorita:"info",   emoji:"📝" },
  VERBALE_TASK_GENERATI: { categoria:"verbali",   priorita:"info",   emoji:"📝" },
  // Economia
  BUDGET_SUPERATO:       { categoria:"economia",  priorita:"critico",emoji:"🔴" },
  // Dipendenti
  DIPENDENTE_CREATO:     { categoria:"dipendenti",priorita:"info",   emoji:"👷" },
};
